export default __webpack_public_path__ + "static/media/left-arrow.53878c51.svg";